export default __webpack_public_path__ + "static/media/Group 7244.45dc9081.png";